var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    borders = _ref.borders,
    spacing = _ref.spacing;
  return {
    overlayZIndex: '2222',
    overlayBarColor: colors.electric,
    overlayBarSize: '0.3rem'
  };
};
export default generateComponentTheme;